import { NewsState } from '@store/slices/news.slice'

export const getNewsStateTranslation = (
  stateValue: NewsState | string | number
): string => {
  if (stateValue == NewsState.IN_PROGRESS) {
    return 'Rozpracováno'
  } else if (stateValue == NewsState.REVIEW_OK) {
    return 'Schváleno'
  } else if (stateValue == NewsState.PUBLISHED) {
    return 'Publikováno'
  } else if (stateValue == NewsState.TO_REVIEW) {
    return 'Ke Schválení'
  } else if (stateValue == NewsState.ERROR) {
    return 'Chyba'
  } else {
    return 'other'
  }
}

export const getStateColor = (
  stateValue: NewsState | string | number
): string => {
  if (stateValue == NewsState.IN_PROGRESS) {
    return 'progress'
  } else if (stateValue == NewsState.REVIEW_OK) {
    return 'reviewed'
  } else if (stateValue == NewsState.PUBLISHED) {
    return 'published'
  } else if (stateValue == NewsState.TO_REVIEW) {
    return 'review'
  } else if (stateValue == NewsState.ERROR) {
    return 'error'
  } else {
    return 'other'
  }
}
